#image_uploader_preview {
  max-width: 500px;
  max-height: 500px;
}
